import React from "react"
import { H5, Image, P } from "../../../../AbstractElements";
import { Link } from "react-router-dom";
import { dynamicImage } from "../../../../Service/DynamicImage";
import { MANAGE_ORDER_COLUMN } from "../../../../Data/Dashboard";


export const ManageOrderTableBody = () => {
  return (
    <tbody>
      {MANAGE_ORDER_COLUMN.map((item, index) => (
        <tr key={index}>
          <td>
            <div className="d-flex align-items-center">
              <div className="flex-shrink-0">
                <Image src={dynamicImage(`dashboard/user/${item.image}`)} alt="" />
              </div>
              <div className="flex-grow-1 ms-2">
                <Link to={`${process.env.PUBLIC_URL}/ecommerce/product-page`}>
                  <H5>{item.title}</H5>
                  <span>{item.spanText}</span>
                </Link>
              </div>
            </div>
          </td>
          <td><P>{item.productId}</P></td>
          <td><H5>{item.mail}</H5></td>
          <td><P className="hover-box">{item.stock}</P></td>
          <td><P>{item.payment}</P></td>
          <td><span className="font-primary">{item.amount}</span></td>
          <td><div className="order"><P>{item.status}</P></div></td>
        </tr>
      ))}
    </tbody>
  );
};
